import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
    timeFormatter,
    timeValueGetter,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";

export default () => [
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            headerName: getLocalizedString("code"),
            field: "Código de empleado",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Observaciones",
            headerName: getLocalizedString("observations"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Marcas inconsistentes",
            headerName: getLocalizedString("GT_ALERT3"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Atraso en la entrada",
            headerName: getLocalizedString("entryDelay"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Demora en el break",
            headerName: getLocalizedString("delayInBreak"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Retiro anticipado",
            headerName: getLocalizedString("earlyWithdrawal"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Ausencias no justificadas",
            headerName: getLocalizedString("unjustifiedAbsencesAlt"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Trabajo en día no programado",
            headerName: getLocalizedString("GT_ALERT2"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Horas extras sin autorizar",
            headerName: getLocalizedString("unauthorizedOvertime"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Día con cambio de horario",
            headerName: getLocalizedString("dayWithScheduleChange"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            headerName: getLocalizedString("employeesProcessFecha"),
            field: "Fecha",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Día",
            headerName: getLocalizedString("day"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            headerName: getLocalizedString("filterHorario"),
            field: "Horario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            headerName: getLocalizedString("entrada"),
            field: "Entrada",
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Salida al break",
            headerName: getLocalizedString("breakExit"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Regreso del break",
            headerName: getLocalizedString("returnFromBreak"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            headerName: getLocalizedString("salida"),
            field: "Salida",
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Horas turno",
            headerName: getLocalizedString("shiftHours"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Marcas de asistencia",
            headerName: getLocalizedString("assistanceTitle"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Horas de permanencia",
            headerName: getLocalizedString("permanenceHours"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Antes",
            headerName: getLocalizedString("before"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "No imputable",
            headerName: getLocalizedString("nonChargeable"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Normal",
            headerName: getLocalizedString("normal"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Después",
            headerName: getLocalizedString("after"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Total extras",
            headerName: getLocalizedString("totalExtras"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Extras autorizadas",
            headerName: getLocalizedString("authorizedOvertimes"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Extras sin autorizar",
            headerName: getLocalizedString("unauthorizedExtras"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            field: "Horas ausencia",
            headerName: getLocalizedString("absenceHours"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysisIndividual],
        config: {
            headerName: getLocalizedString("comments"),
            field: "Comentarios",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            headerName: getLocalizedString("code"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
            pinned: "left",
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
            pinned: "left",
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            headerName: getLocalizedString("shift"),
            field: "Turno",
            filter: "agSetColumnFilter",
            pinned: "left",
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Observaciones",
            headerName: getLocalizedString("observations"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Registros",
            headerName: getLocalizedString("records"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Marcas inconsistentes",
            headerName: getLocalizedString("GT_ALERT3"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Atrasos en la entrada",
            headerName: getLocalizedString("entryDelays"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Demora en el break",
            headerName: getLocalizedString("delayInBreak"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Retiro anticipado",
            headerName: getLocalizedString("earlyWithdrawal"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Ausencias sin justificar",
            headerName: getLocalizedString("unjustifiedAbsences"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Horas normales",
            headerName: getLocalizedString("normalHours"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Total de horas extras",
            headerName: getLocalizedString("totalExtraHours"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Horas extras autorizadas",
            headerName: getLocalizedString("authorizedOvertimeHoursLong"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Horas extras sin autorizar",
            headerName: getLocalizedString("unauthorizedOvertime"),
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Trabajo en días no programados",
            headerName: getLocalizedString("workOnUnscheduledDays"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Feriados",
            headerName: getLocalizedString("govHolidays"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Días con cambio de horario",
            headerName: getLocalizedString("daysWithScheduleChange"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: "Obra o faena",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Tipo de calendario",
            headerName: getLocalizedString("calendarType"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Tipo de control horario",
            headerName: getLocalizedString("scheduleControlType"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            headerName: getLocalizedString("jornadaType"),
            field: "Tipo de jornada",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Horas extras liberadas",
            headerName: getLocalizedString("freedExtraHours"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistanceAnalysis],
        config: {
            field: "Código de tarjeta/credencial",
            headerName: getLocalizedString("cardCode"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['assistanceAnalyisisDashboardThirdPaymentParty'],
        config: {
            field: 'Código de tercero',
            headerName: getLocalizedString("thirdPartyCode"),
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['assistanceAnalyisisDashboardThirdPaymentParty'],
        config: {
            field: 'Nombre del tercero',
            headerName: getLocalizedString("thirdPartyName"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['assistanceAnalyisisDashboardThirdPaymentParty'],
        config: {
            headerName: getLocalizedString("clasification"),
            field: 'Clasificación',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['assistanceAnalyisisDashboardThirdPaymentParty'],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: 'Código de empleado',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['assistanceAnalyisisDashboardThirdPaymentParty'],
        config: {
            headerName: getLocalizedString("namesAndLastnames"),
            field: 'Apellidos y nombres',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['assistanceAnalyisisDashboardThirdPaymentParty'],
        config: {
            headerName: getLocalizedString("paymentMethod"),
            field: 'Forma de pago',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['assistanceAnalyisisDashboardThirdPaymentParty'],
        config: {
            headerName: getLocalizedString("bank"),
            field: 'Banco',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['assistanceAnalyisisDashboardThirdPaymentParty'],
        config: {
            headerName: getLocalizedString("bankAccount"),
            field: 'Cuenta bancaria',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['assistanceAnalyisisDashboardThirdPaymentParty'],
        config: {
            headerName: getLocalizedString("paymentType"),
            field: 'Tipo de pago',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['assistanceAnalyisisDashboardThirdPaymentParty'],
        config: {
            field: 'Valor a pagar',
            headerName: getLocalizedString("amountToPay"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['assistanceAnalyisisDashboardThirdPaymentParty'],
        config: {
            headerName: getLocalizedString("comments"),
            field: 'Comentarios',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantity"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantity"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantity"],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantity"],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantity"],
        config: {
            headerName: getLocalizedString("function"),
            field: "Función",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantity"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantity"],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantity"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantity"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantity"],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "Tipo de contrato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantityGHD"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantityGHD"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantityGHD"],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantityGHD"],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantityGHD"],
        config: {
            headerName: getLocalizedString("function"),
            field: "Función",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantityGHD"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantityGHD"],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantityGHD"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantityGHD"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardQuantityGHD"],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "Tipo de contrato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserKPIs"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserKPIs"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserKPIs"],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserKPIs"],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: "Fecha de contratación",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserKPIs"],
        config: {
            headerName: getLocalizedString("outcomeDate"),
            field: "Fecha de egreso",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserKPIs"],
        config: {
            headerName: getLocalizedString("shift"),
            field: "Turno",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserKPIs"],
        config: {
            headerName: getLocalizedString("filterHorario"),
            field: "Horario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserKPIs"],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserKPIs"],
        config: {
            headerName: getLocalizedString("function"),
            field: "Función",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserKPIs"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserKPIs"],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserKPIs"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserKPIs"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserKPIs"],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "Tipo de contrato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardValuesPerConcept"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardValuesPerConcept"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardValuesPerConcept"],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardValuesPerConcept"],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardValuesPerConcept"],
        config: {
            headerName: getLocalizedString("function"),
            field: "Función",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardValuesPerConcept"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardValuesPerConcept"],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardValuesPerConcept"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardValuesPerConcept"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardValuesPerConcept"],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "Tipo de contrato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCompanyCost"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCompanyCost"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCompanyCost"],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCompanyCost"],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCompanyCost"],
        config: {
            headerName: getLocalizedString("function"),
            field: "Función",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCompanyCost"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCompanyCost"],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCompanyCost"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ['assistanceAnalyisisDashboardCompanyCost'],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: "Obra o Faena",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCompanyCost"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCompanyCost"],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "Tipo de contrato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCompanyCost"],
        config: {
            headerName: getLocalizedString("employeesProcessCentroBeneficio"),
            field: "Centro de costo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCompanyCost"],
        config: {
            field: "Total de Haberes",
            headerName: getLocalizedString("totalEarnings"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCompanyCost"],
        config: {
            field: "Total aportes del empleador",
            headerName: getLocalizedString("totalEmployerContributions"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCompanyCost"],
        config: {
            field: "Total costo empresa",
            headerName: getLocalizedString("totalCompanyCost"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardTopBottom"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardTopBottom"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardTopBottom"],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardTopBottom"],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardTopBottom"],
        config: {
            headerName: getLocalizedString("function"),
            field: "Función",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardTopBottom"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardTopBottom"],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardTopBottom"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardTopBottom"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardTopBottom"],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "Tipo de contrato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            headerName: getLocalizedString("function"),
            field: "Función",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "Tipo de contrato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            field: "Total de Haberes (Brutos)",
            headerName: getLocalizedString("totalGrossEarnings"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            field: "Total de haberes Imponibles",
            headerName: getLocalizedString("totalTaxableWages"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            field: "Total de leyes sociales",
            headerName: getLocalizedString("totalSocialLaws"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            field: "Total de haberes tributables",
            headerName: getLocalizedString("totalTaxableIncome"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            field: "Total Impuesto",
            headerName: getLocalizedString("totalTax"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            field: "Total de haberes exentos",
            headerName: getLocalizedString("totalExemptEarnings"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            field: "Total de descuentos",
            headerName: getLocalizedString("totalDiscounts"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            field: "Total de descuentos legales",
            headerName: getLocalizedString("totalLegalDeductions"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            field: "Total de descuentos varios",
            headerName: getLocalizedString("totalVariousDiscounts"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            headerName: getLocalizedString("totalLiquidsNet"),
            field: "Total Líquidos/netos",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            field: "Total aportes del empleador (Aportes patronales)",
            headerName: getLocalizedString("totalEmployerContributionsNote"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            field: "Total de beneficios corporativos (Beneficios empresariales)",
            headerName: getLocalizedString("corporateBenefitsTotalCorporateBenefits"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            field: "Total costo empresa estándar",
            headerName: getLocalizedString("totalStandardCompanyCost"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardGlobalValues"],
        config: {
            field: "Total costo empresa con beneficios corporativos",
            headerName: getLocalizedString("totalCompanyCostWithCorporateBenefits"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config: {
            headerName: getLocalizedString("function"),
            field: "Función",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "Tipo de contrato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config: {
            field: "Haberes con aportes",
            headerName: getLocalizedString("employeesProcessHaberesAportes"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config: {
            field: "Descuentos legales",
            headerName: getLocalizedString("employeesProcessDescuentosLegales"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config: {
            field: "Haberes sin aporte",
            headerName: getLocalizedString("salariesWithoutContribution"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config: {
            field: "Descuentos varios",
            headerName: getLocalizedString("employeesProcessDescuentosVarios"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardAnalytics"],
        config: {
            field: "Líquido/Neto",
            headerName: getLocalizedString("employeesProcessTotal"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardBankDistribution"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardBankDistribution"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardBankDistribution"],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardBankDistribution"],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardBankDistribution"],
        config: {
            headerName: getLocalizedString("function"),
            field: "Función",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardBankDistribution"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardBankDistribution"],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardBankDistribution"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardBankDistribution"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardBankDistribution"],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "Tipo de contrato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardBankDistribution"],
        config: {
            headerName: getLocalizedString("liquidNet"),
            field: "Liquido/Neto",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCloud"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCloud"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCloud"],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCloud"],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCloud"],
        config: {
            headerName: getLocalizedString("function"),
            field: "Función",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCloud"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCloud"],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCloud"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCloud"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCloud"],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "Tipo de contrato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCloud"],
        config: {
            headerName: getLocalizedString("reference"),
            field: "Referencia",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardCloud"],
        config: {
            headerName: getLocalizedString("valuesOccurrences"),
            field: "Valores/Ocurrencias",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserGraphs"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserGraphs"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserGraphs"],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserGraphs"],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserGraphs"],
        config: {
            headerName: getLocalizedString("function"),
            field: "Función",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserGraphs"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserGraphs"],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserGraphs"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserGraphs"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardUserGraphs"],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "Tipo de contrato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config:
        {
            field: "Proceso de cálculo",
            headerName: getLocalizedString("selectCalcMethod"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: "Fecha de contratación",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            headerName: getLocalizedString("outcomeDate"),
            field: "Fecha de egreso",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            headerName: getLocalizedString("shift"),
            field: "Turno",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            headerName: getLocalizedString("filterHorario"),
            field: "Horario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            headerName: getLocalizedString("function"),
            field: "Función",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            headerName: getLocalizedString("section"),
            field: "Sección",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            headerName: getLocalizedString("laborUnion"),
            field: "Sindicato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "Tipo de contrato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            field: "Institución de Previsión",
            headerName: getLocalizedString("socialSecurityInstitution"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["assistanceAnalyisisDashboardConceptGroups"],
        config: {
            field: "Institución de Salud",
            headerName: getLocalizedString("healthInstitutionUppercase"),
            filter: "agSetColumnFilter",
        }
    },
]